import axios from 'axios';
import { API_ENDPOINTS } from './apiEndpoints';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: API_ENDPOINTS.BASE_URL,
  // timeout: 10000, // Timeout in milliseconds
});

// Function to determine the headers dynamically
const getHeaders = (token, contentType = 'application/json') => ({
//   Authorization: `Bearer ${token}`,
  'Content-Type': contentType,
});

// Generic reusable functions
const apiService = {
  get: async (endpoint, token) => {
    try {
      const response = await axiosInstance.get(endpoint, {
        headers: getHeaders(token),
      });
      return response.data;
    } catch (error) {
      console.error(`GET ${endpoint} failed:`, error);
      throw error.response?.data || error.message;
    }
  },

  post: async (endpoint, data, token, contentType = 'application/json') => {
    try {
      console.log("🚀 ~ post: ~ endpoint:", endpoint)
      const response = await axiosInstance.post(endpoint, data, {
        headers: getHeaders(token, contentType),
      });
      
      return response.data;
    } catch (error) {
      console.error(`POST ${endpoint} failed:`, error);
      throw error.response?.data || error.message;
    }
  },

  put: async (endpoint, data, token, contentType = 'application/json') => {
    try {
      const response = await axiosInstance.put(endpoint, data, {
        headers: getHeaders(token, contentType),
      });
      return response.data;
    } catch (error) {
      console.error(`PUT ${endpoint} failed:`, error);
      throw error.response?.data || error.message;
    }
  },

  delete: async (endpoint, token) => {
    try {
      const response = await axiosInstance.delete(endpoint, {
        headers: getHeaders(token),
      });
      return response.data;
    } catch (error) {
      console.error(`DELETE ${endpoint} failed:`, error);
      throw error.response?.data || error.message;
    }
  },
};

export default apiService;
